import { Link, List, ListItem, ListItemText, Typography } from "@mui/material";

const TermsOfServiceContent = () => {
  return (
    <>
      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        1. Uvod
      </Typography>
      <Typography variant="body1" paragraph>
        Dobrodošli u Kantz, platformu za rezervaciju radnog prostora razvijenu
        od strane kompanije{" "}
        <strong>HOOLOOVOO DOO BEOGRAD (SAVSKI VENAC)</strong>, sa sedištem na
        adresi Ljutiće Bogdana 9, Beograd, matični broj: 20753013, PIB:
        107190299 („HOOLOOVOO“, „Mi“, „Naš“). Ovi Uslovi korišćenja ("Uslovi")
        regulišu vaše korišćenje naših digitalnih usluga, uključujući bilo koji
        povezani softver, veb-sajtove i funkcionalnosti (zajedno označeni kao:
        "Usluge"). Naše Usluge podrazumevaju činjenje dostupnom i održavanje
        Kantz aplikacije („Aplikacija“), putem našeg veb-sajta{" "}
        <Link
          href="https://otp.kantz.app"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          otp.kantz.app
        </Link>
        , koja je namenjena za rezervisanje radnih jedinica, odnosno mesta za
        rad koja uključuju radni sto i stolicu i prostorija za sastanke u
        deljenim kancelarijskim prostorima (Shared Office Space) ili u okviru
        kompanija koje raspolažu prostorom kapaciteta manjeg od ukupnog broja
        zaposlenih. Pristupanjem i korišćenjem naših Usluga, potvrđujete i
        prihvatate ove Uslove, i obavezujete se da ih poštujete. Naša
        posvećenost zaštiti podataka potvrđena je našom ISO 27001
        sertifikacijom.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        2. Prihvatanje uslova
      </Typography>
      <Typography variant="body1" paragraph>
        Korišćenjem Usluga prihvatate ove Uslove i našu{" "}
        <Link href="/privacy-policy" underline="hover">
          Politiku privatnosti
        </Link>
        . Ukoliko niste saglasni sa bilo kojim delom ovih Uslova, molimo Vas da
        se uzdržite od korišćenja Usluga. Zadržavamo pravo da povremeno menjamo
        ove Uslove. Nastavak korišćenja znači da prihvatate izmene.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        3. Definicije
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>"Sadržaj":</strong> tekst, slike, fajlovi, podaci i druge
            informacije koje se razmenjuju kroz platformu.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>"Korisnik":</strong> osoba ili entitet koji koristi Usluge.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>"Pretplata":</strong> komercijalni plan koji omogućava
            pristup dodatnim funkcijama.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>"Vi":</strong> odnosi se na vas kao korisnika.
          </ListItemText>
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        4. Opis usluga
      </Typography>
      <Typography variant="body1" paragraph>
        Aplikacija Kantz omogućava organizacijama upravljanje i rezervaciju
        radnog prostora, uključujući stolove, sobe i druge resurse, uz napredne
        funkcionalnosti kao što su sinhronizacija sa Microsoft kalendarima i
        korisničke grupe. Dostupna je osnovna i napredna verzija platforme.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        4.1. Dostupnost
      </Typography>
      <Typography variant="body1" paragraph>
        Težimo 24/7 dostupnosti, ali ne garantujemo neprekidan rad. Privremeni
        prekidi mogu nastati zbog održavanja ili nepredviđenih problema.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        5. Korisnički nalozi
      </Typography>
      <Typography variant="body1" paragraph>
        Za pristup određenim funkcijama neophodna je registracija naloga sa
        tačnim informacijama. Vi ste odgovorni za ažurnost i sigurnost podataka
        o nalogu.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        5.1. Sigurnost
      </Typography>
      <Typography variant="body1" paragraph>
        Obavezujete se da nećete deliti pristupne podatke i da ćete prijaviti
        bilo kakvo neovlašćeno korišćenje naloga.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        6. Pretplate i plaćanja
      </Typography>
      <Typography variant="body1" paragraph>
        Neke funkcije Kantz-a zahtevaju pretplatu. Pretplatom se saglašavate da
        platite odgovarajuće naknade za pretplatu i sve povezane troškove.
        Naknade za pretplatu naplaćuju se unapred na ponavljajućoj osnovi i nisu
        povratne.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        6.1. Promene naknada
      </Typography>
      <Typography variant="body1" paragraph>
        Zadržavamo pravo da izmenimo naknade za pretplatu uz prethodno
        obaveštenje. Ako se ne slažete sa promenom naknada, možete otkazati
        svoju pretplatu pre nego što nove naknade stupe na snagu.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        7. Ponašanje korisnika i zabranjene aktivnosti
      </Typography>
      <Typography variant="body1" paragraph>
        Slažete se da se nećete upuštati u bilo koju od sledećih zabranjenih
        aktivnosti:
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            Kršenje bilo kojih važećih zakona ili propisa.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            Kršenje prava intelektualne svojine drugih.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            Distribucija štetnog ili uvredljivog sadržaja.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            Pokušaj ometanja sigurnosti ili funkcionalnosti Usluga.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            Lažno predstavljanje kao druga osoba ili entitet.
          </ListItemText>
        </ListItem>
      </List>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        7.1. Specifična ograničenja
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Štetni Sadržaj:</strong> Ne smete generisati ili distribuirati
        sadržaj koji podržava uznemiravanje, mržnju ili nasilje.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Malware:</strong> Kreiranje ili distribucija zlonamernog
        softvera je strogo zabranjena.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Obmanjujuće Prakse:</strong> Lažno predstavljanje porekla ili
        autorstva sadržaja je zabranjeno.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        8. Prava intelektualne svojine
      </Typography>
      <Typography variant="body1" paragraph>
        HOOLOOVOO zadržava sva prava u vezi sa Uslugama, uključujući patente,
        žigove, poslovne tajne i autorska prava. Dodeljuje vam se ograničena,
        neprenosiva licenca za korišćenje Usluga u okviru vaših internih
        potreba. Zabranjeno je modifikovanje, distribucija, podlicenciranje ili
        obrnuti inženjering.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        9. Smernice za sadržaj
      </Typography>
      <Typography variant="body1" paragraph>
        Vi ste odgovorni za osiguranje da bilo koji sadržaj koji podnesete bude
        u skladu sa ovim Uslovima i važećim zakonima. Mi ne podržavamo nijedan
        sadržaj koji podnose korisnici i odričemo se bilo kakve odgovornosti u
        vezi sa takvim sadržajem. Zadržavamo pravo da pregledamo, uklonimo ili
        onemogućimo pristup bilo kojem sadržaju koji krši ove Uslove ili naše{" "}
        <Link href="/privacy-policy" underline="hover">
          Politike privatnosti
        </Link>
        .
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        10. Privatnost i zaštita podataka
      </Typography>
      <Typography variant="body1" paragraph>
        Vaša privatnost nam je važna. Molimo vas da pregledate našu{" "}
        <Link href="/privacy-policy" underline="hover">
          Politiku privatnosti
        </Link>
        , koja objašnjava kako prikupljamo, koristimo i štitimo vaše podatke o
        ličnosti. Kao kompanija sertifikovana prema ISO 27001, pridržavamo se
        strogih standarda informacione sigurnosti kako bismo zaštitili vaše
        podatke.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        10.1 Bezbednost podataka
      </Typography>
      <Typography variant="body1" paragraph>
        Implementiramo razumne mere sigurnosti za zaštitu vaših podataka;
        međutim, ne možemo garantovati apsolutnu sigurnost. Vi ste odgovorni za
        zaštitu informacija o vašem nalogu.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        11. Usluge trećih strana i integracije
      </Typography>
      <Typography variant="body1" paragraph>
        Naše usluge mogu uključivati linkove ka veb-sajtovima ili uslugama
        trećih strana. Ne podržavamo niti preuzimamo odgovornost za bilo koje
        veb-sajtove, usluge ili sadržaj trećih strana.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        11.1 Uslovi trećih strana
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše interakcije sa uslugama trećih strana regulisane su njihovim
        odgovarajućim uslovima i odredbama. Vi ste odgovorni za pregledanje i
        poštovanje tih uslova.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        12. Ograničenje odgovornosti
      </Typography>
      <Typography variant="body1" paragraph>
        U meri u kojoj to zakon dozvoljava, HOOLOOVOO ne snosi odgovornost za
        bilo kakvu posrednu ili dodatnu štetu koja može nastati korišćenjem
        aplikacije Kantz, uključujući, na primer, gubitak podataka, prekid
        poslovanja ili druge posledice koje nisu direktno izazvane radom
        aplikacije.
      </Typography>
      <Typography variant="body1" paragraph>
        Ovi Uslovi korišćenja zamenjuju sve ranije sporazume ili dogovore koje
        ste možda imali sa HOOLOOVOO-om, u meri u kojoj su oni u suprotnosti sa
        ovim dokumentom.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        12.1 Odricanje od garancija
      </Typography>
      <Typography variant="body1" paragraph>
        Usluge se pružaju "takve kakve jesu" bez bilo kakvih garancija bilo koje
        vrste, bilo izričitih ili podrazumevanih. Mi i naši dobavljači i davaoci
        licenci ovim se odričemo svih garancija da će aplikacija biti prikladna
        za svaku pojedinačnu svrhu korisnika, osim onoga što je izričito
        navedeno u ovim Uslovima. Ne garantujemo da će naše Usluge biti bez
        grešaka ili da će pristup biti kontinuiran ili neprekidan.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        13. Oslobađanje od odgovornosti
      </Typography>
      <Typography variant="body1" paragraph>
        Slažete se da ćete osloboditi odgovornosti i zaštititi HOOLOOVOO,
        njegove filijale i njihove direktore, zaposlene i agente od bilo kakvih
        zahteva, odgovornosti, šteta, gubitaka ili troškova koji proizlaze iz
        vašeg korišćenja Usluga ili kršenja ovih Uslova.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        14. Izmene usluge
      </Typography>
      <Typography variant="body1" paragraph>
        Zadržavamo pravo da izmenimo ili prekinemo, privremeno ili trajno,
        Usluge (ili bilo koji njihov deo) sa ili bez obaveštenja. Ne snosimo
        odgovornost prema vama ili bilo kojoj trećoj strani za bilo kakve
        izmene, suspenzije ili prekide Usluga.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        15. Prestanak i suspenzija
      </Typography>
      <Typography variant="body1" paragraph>
        Možemo suspendovati ili ukinuti vaš pristup Uslugama u bilo kojem
        trenutku, sa ili bez razloga ili obaveštenja. Nakon prestanka, sve
        licence i prava dodeljena vama prema ovim Uslovima odmah prestaju.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        15.1 Prestanak od strane korisnika
      </Typography>
      <Typography variant="body1" paragraph>
        Možete ukinuti svoj nalog u bilo kojem trenutku prateći uputstva na
        našem veb-sajtu. Nakon prestanka, morate prestati sa svim korišćenjem
        Usluga.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        16. Primena zakona i rešavanje sporova
      </Typography>
      <Typography variant="body1" paragraph>
        Ovi Uslovi su regulisani zakonima Republike Srbije. Svi sporovi koji
        proizlaze iz ili su povezani sa ovim Uslovima ili Uslugama biće rešavani
        isključivo pred nadležnim sudovima u Beogradu, Srbija.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        16.1 Proces rešavanja sporova
      </Typography>
      <Typography variant="body1" paragraph>
        Pre nego što pokrenete bilo kakav sudski ili drugi postupak, saglasni
        ste da ćete pokušati da spor rešite neformalnim putem, kontaktiranjem
        nas na{" "}
        <Link href="mailto:support@kantz.app" underline="hover">
          support@kantz.app
        </Link>
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        17. Obaveštenja i komunikacije
      </Typography>
      <Typography variant="body1" paragraph>
        Možemo vam slati obaveštenja o radu i funkcionalnostima Aplikacije putem
        e-pošte ili postavljanjem obaveštenja na naš veb-sajt.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        18. Bezbednost i obaveze usklađenosti
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        18.1 Zabranjena upotreba uređaja i softvera
      </Typography>
      <Typography variant="body1" paragraph>
        Ne smete koristiti bilo koji uređaj, softver ili rutinu koji ometaju
        pravilno funkcionisanje naše usluge. Ovo uključuje bilo kakvo
        neovlašćeno nadgledanje ili kopiranje materijala sa naše usluge bez
        prethodnog pismenog pristanka.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        18.2 Instaliranje štetnog materijala
      </Typography>
      <Typography variant="body1" paragraph>
        Instaliranje virusa, trojanskih konja, crva, logičkih bombi ili drugog
        zlonamernog ili tehnološki štetnog materijala strogo je zabranjeno.
        Takve radnje će rezultirati trenutnim prestankom vašeg pristupa Uslugama
        i mogu dovesti do pokretanja odgovarajućeg sudskog ili drugog postupka.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        18.3 Neovlašćena upotreba materijala
      </Typography>
      <Typography variant="body1" paragraph>
        Ne smete koristiti bilo koji ručni proces za nadgledanje ili kopiranje
        bilo kog materijala na našim Uslugama ili koristiti ga za bilo koju
        neovlašćenu svrhu bez našeg prethodnog pismenog pristanka.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        18.4 Zloupotreba i ometanje
      </Typography>
      <Typography variant="body1" paragraph>
        Zloupotreba, oštećenje, ometanje ili prekidanje Usluga, uključujući
        kreiranje ili distribuciju neželjene komunikacije, je zabranjeno. Ne
        smete se upuštati u aktivnosti koje bi mogle ugroziti sigurnost ili
        funkcionisanje Usluga.
      </Typography>

      {/* Nastavak do kraja */}
      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        19. Propisi o sadržaju i ponašanju
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        19.1 Štetni sadržaj
      </Typography>
      <Typography variant="body1" paragraph>
        Strogo je zabranjeno generisanje sadržaja koji podržava uznemiravanje,
        prikazuje mržnju, podstiče ili veliča nasilje, ili slavi patnju ili
        poniženje.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        19.2 Generisanje Malware-a
      </Typography>
      <Typography variant="body1" paragraph>
        Kreiranje ili distribucija koda namenjenog za oštećenje, ometanje ili
        neovlašćeni pristup računarskom sistemu je zabranjeno.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        19.3 Rizici fizičkog oštećenja
      </Typography>
      <Typography variant="body1" paragraph>
        Korisnici su dužni da koriste rezervisane prostore i opremu sa pažnjom i
        u skladu sa njihovom namenom, shodno pravilima važećim za konkretan
        objekat. Bilo kakvo namerno oštećenje, neovlašćeno menjanje, uništavanje
        ili nepravilno korišćenje radnog prostora, nameštaja, uređaja ili druge
        opreme strogo je zabranjeno i može dovesti do naknade štete i/ili
        ukidanja prava na korišćenje Aplikacije.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        19.4 Uvređujući i obmanjujući sadržaj
      </Typography>
      <Typography variant="body1" paragraph>
        Kreiranje sadržaja koji podstiče mržnju, uznemiravanje ili
        maltretiranje, ili koji uključuje obmanjujuće aktivnosti, prevare ili
        phishing, je zabranjeno.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        20. Intelektualna svojina i unošenje sadržaja
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        20.1 Sadržaj koji unosite
      </Typography>
      <Typography variant="body1" paragraph>
        Možete unositi tekst, dokumente ili druge materijale našim Uslugama za
        obradu. Time potvrđujete da imate sva potrebna prava, licence i dozvole
        za unošenje sadržaja.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        20.2 Usklađenost sa zakonima
      </Typography>
      <Typography variant="body1" paragraph>
        Obavezujete se da sadržaj koji unosite u Aplikaciju neće biti nezakonit,
        netačan, obmanjujući, uvredljiv niti sadržavati podatke čija je obrada
        ograničena ili zabranjena posebnim propisima. Dužni ste da se
        pridržavate svih važećih zakona i propisa prilikom korišćenja
        Aplikacije.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        20.3 Prava intelektualne svojine
      </Typography>
      <Typography variant="body1" paragraph>
        Sva prava intelektualne svojine u okviru Usluga pripadaju HOOLOOVOO-u.
        Ne smete kršiti ili prisvajati ova prava ili prava bilo koje treće
        strane.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        21. Zaštita podataka i usklađenost
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        21.1 Korišćenje podataka
      </Typography>
      <Typography variant="body1" paragraph>
        Slažete se da ćete se pridržavati važećih propisa o zaštiti podataka i
        da nećete zloupotrebljavati, oštetiti, ometati ili prekidati naše
        Usluge.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        21.2 Mere sigurnosti
      </Typography>
      <Typography variant="body1" paragraph>
        Ne smete pokušavati da zaobiđete sigurnosne mere ili namerno pokrećete
        model da se ponaša suprotno našim politikama.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        22. Ograničenje i oslobađanje odgovornosti
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        22.1 Ograničenje odgovornosti
      </Typography>
      <Typography variant="body1" paragraph>
        Aplikaciju koristite na ličnu odgovornost. HOOLOOVOO neće biti odgovoran
        za bilo kakve direktne ili indirektne štete koje mogu proizaći iz vašeg
        korišćenja Usluga.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        22.2 Oslobađanje odgovornosti
      </Typography>
      <Typography variant="body1" paragraph>
        Saglasni ste da oslobodite HOOLOOVOO od bilo kakvih zahteva koji mogu
        proizaći iz vašeg kršenja ovih Uslova.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        23. Preopterećenje usluge i neovlašćen pristup
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        23.1 Preopterećenje usluge
      </Typography>
      <Typography variant="body1" paragraph>
        Ne smete koristiti naše Usluge na način koji bi ih mogao onesposobiti,
        preopteretiti, oštetiti ili narušiti.
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        23.2 Neovlašćen pristup
      </Typography>
      <Typography variant="body1" paragraph>
        Pokušaj neovlašćenog pristupa našim Uslugama ili povezanim serverima je
        zabranjen.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        24. Promene uslova
      </Typography>
      <Typography variant="body1" paragraph>
        HOOLOOVOO može ažurirati ove Uslove s vremena na vreme. Pozivamo vas da
        povremeno pregledate ove Uslove za bilo kakve promene. Ako se izvrše
        značajne promene, obavestićemo vas izmenom datuma stupanja na snagu
        Uslova, a u nekim slučajevima možemo pružiti dodatno obaveštenje (kao
        što je slanje obaveštenja putem e-pošte).
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        25. Završne odredbe
      </Typography>
      <Typography variant="body1" paragraph>
        Ovi Uslovi predstavljaju sveobuhvatan sporazum između vas i HOOLOOVOO-a
        u vezi sa korišćenjem naših Usluga i Aplikacije.
      </Typography>
      <Typography variant="body1" paragraph>
        Radi izbegavanja sumnje, na sve što ovim Uslovima nije izričito uređeno
        primenjivaće se propisi Republike Srbije, koje pravo će biti merodavno i
        u slučaju spora u vezi sa ovim Uslovima, odnosno obradom podataka o
        ličnosti, a koji spor se ima rešavati pred stvarno nadležnim sudom u
        Beogradu, Republika Srbija.
      </Typography>
      <Typography variant="body1" paragraph>
        Ukoliko se bilo koja odredba ovih Uslova utvrdi kao nevažeća ili
        neizvršiva, takva odredba neće uticati na važenje i izvršivost
        preostalih odredaba, koje će ostati na snazi i nastaviti da proizvode
        pravno dejstvo.
      </Typography>
      <Typography variant="body1" paragraph>
        Propuštanje ili neprimenjivanje bilo kog prava ili ovlašćenja od strane
        HOOLOOVOO-a u okviru ovih Uslova korišćenja neće značiti odricanje od
        tog prava ili ovlašćenja, niti će uticati na mogućnost njegovog
        naknadnog ostvarivanja.
      </Typography>
      <Typography variant="body1" paragraph>
        Za sva pitanja i nedoumice, kontaktirajte nas na{" "}
        <Link href="mailto:support@kantz.app" underline="hover">
          support@kantz.app
        </Link>
        . Hvala što koristite Kantz! Naša ISO 27001 sertifikacija potvrđuje našu
        posvećenost bezbednosti i zaštiti podataka.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        26. Datum stupanja na snagu
      </Typography>
      <Typography variant="body1" paragraph>
        Ovi uslovi su na snazi od <strong>1. avgusta 2025. godine.</strong>
      </Typography>
    </>
  );
};

export default TermsOfServiceContent;
